import * as Types from '../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TriggerGhostwriterApplyMutationVariables = Types.Exact<{
  input: Types.TriggerGhostwriterApplyInput;
}>;


export type TriggerGhostwriterApplyMutation = { __typename?: 'Mutation', ghostwriter: { __typename?: 'GhostwriterMutations', triggerApply: { __typename?: 'TriggerGhostwriterApplyPayload', taskId?: string | null, application?: { __typename?: 'GhostwriterApplication', id: string, applicationStatus: Types.GhostwriterApplicationStatus } | null, userErrors: Array<{ __typename?: 'GhostwriterUserError', message: string, field?: Array<string> | null, code?: string | null }> } } };


export const TriggerGhostwriterApplyDocument = gql`
    mutation TriggerGhostwriterApply($input: TriggerGhostwriterApplyInput!) {
  ghostwriter {
    triggerApply(input: $input) {
      application {
        id
        applicationStatus
      }
      taskId
      userErrors {
        message
        field
        code
      }
    }
  }
}
    `;
export type TriggerGhostwriterApplyMutationFn = Apollo.MutationFunction<TriggerGhostwriterApplyMutation, TriggerGhostwriterApplyMutationVariables>;

/**
 * __useTriggerGhostwriterApplyMutation__
 *
 * To run a mutation, you first call `useTriggerGhostwriterApplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerGhostwriterApplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerGhostwriterApplyMutation, { data, loading, error }] = useTriggerGhostwriterApplyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTriggerGhostwriterApplyMutation(baseOptions?: Apollo.MutationHookOptions<TriggerGhostwriterApplyMutation, TriggerGhostwriterApplyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerGhostwriterApplyMutation, TriggerGhostwriterApplyMutationVariables>(TriggerGhostwriterApplyDocument, options);
      }
export type TriggerGhostwriterApplyMutationHookResult = ReturnType<typeof useTriggerGhostwriterApplyMutation>;
export type TriggerGhostwriterApplyMutationResult = Apollo.MutationResult<TriggerGhostwriterApplyMutation>;
export type TriggerGhostwriterApplyMutationOptions = Apollo.BaseMutationOptions<TriggerGhostwriterApplyMutation, TriggerGhostwriterApplyMutationVariables>;